import angular from 'angular';
import SessionService from './session.service';

let sessionModule  = angular.module('shared.components.session', [])
  .service('SessionService', SessionService);

export default sessionModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/session/session.js
 **/